import { useNavigate } from "react-router-dom";
import TransferService from "../../services/TransferBetweenWarehouses";
import { useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import withLoader from "../../components/layouts/WithLoader";

const PAGE_SIZES = [10, 25, 50, 100];
const EMPTY_PAGE = { items: [], total: 0, totalPages: 0, page: 0, size: 10 };

const ConfirmTransfert = () => {
  const navigate = useNavigate();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [statusFilter, setStatusFilter] = useState("all");

  // une pagination serveur par tableau : confirmés (1) et non confirmés (0)
  const [confirmed, setConfirmed] = useState(EMPTY_PAGE);
  const [unconfirmed, setUnconfirmed] = useState(EMPTY_PAGE);
  const [loadingConfirmed, setLoadingConfirmed] = useState(false);
  const [loadingUnconfirmed, setLoadingUnconfirmed] = useState(false);

  const fetchTransfers = (isConfirmed, page, size) => {
    const setData = isConfirmed ? setConfirmed : setUnconfirmed;
    const setLoading = isConfirmed ? setLoadingConfirmed : setLoadingUnconfirmed;
    setLoading(true);
    return TransferService.getWarehouseTransfertPaginated(
      0,
      isConfirmed,
      page,
      size
    )
      .then((response) => {
        const data = response.data || {};
        if (Array.isArray(data.success)) {
          setData({
            items: data.success,
            total: data.totalItems || 0,
            totalPages: data.totalPages || 0,
            page: data.currentPage !== undefined ? data.currentPage : page,
            size: data.pageSize || size,
          });
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchTransfers(1, 0, EMPTY_PAGE.size);
    fetchTransfers(0, 0, EMPTY_PAGE.size);
  }, []);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onConfirmHandler = (idTransferBetweenWarehouse) => {
    TransferService.updateWarehouseTransfertIsConfirmed(
      idTransferBetweenWarehouse,
      1
    )
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          // les totaux changent : on recharge la page courante des deux tableaux
          const unconfirmedPage =
            unconfirmed.items.length === 1 && unconfirmed.page > 0
              ? unconfirmed.page - 1
              : unconfirmed.page;
          fetchTransfers(0, unconfirmedPage, unconfirmed.size);
          fetchTransfers(1, confirmed.page, confirmed.size);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  const onViewProductsHandler = (refTransfert) => {
    sessionStorage.setItem("refTransfert", refTransfert);
    navigate("/informationsTransfert");
  };

  const STATUS_OPTIONS = [
    { value: "all", label: "Tous les statuts" },
    { value: "toDo", label: "À confirmer" },
    { value: "doing", label: "Confirmé" },
    { value: "doingSource", label: "En cours" },
    { value: "done", label: "Terminée" },
  ];
  // tout état différent de toDo / doing / doingSource est affiché "terminée"
  const matchesStatus = (element) => {
    if (statusFilter === "all") return true;
    if (statusFilter === "done")
      return !["toDo", "doing", "doingSource"].includes(element.state);
    return element.state === statusFilter;
  };

  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };

  const stateBadge = (state) => {
    if (state === "toDo")
      return <span className="badge badge-warning">à confirmer</span>;
    if (state === "doing")
      return <span className="badge badge-light border">confirmé</span>;
    if (state === "doingSource")
      return <span className="badge badge-dark">en cours</span>;
    return <span className="badge badge-success">terminée</span>;
  };

  // petite fenêtre de pages autour de la page courante : 1 … 4 5 [6] 7 8 … 49
  const pageNumbers = (page, totalPages) => {
    const pages = new Set([0, totalPages - 1]);
    for (let p = page - 2; p <= page + 2; p++) {
      if (p >= 0 && p < totalPages) pages.add(p);
    }
    const sorted = [...pages].sort((a, b) => a - b);
    const result = [];
    sorted.forEach((p, i) => {
      if (i > 0 && p - sorted[i - 1] > 1) result.push("gap-" + p);
      result.push(p);
    });
    return result;
  };

  const renderPagination = (data, isConfirmed, loading) => {
    if (data.total === 0) return null;
    const from = data.page * data.size + 1;
    const to = Math.min((data.page + 1) * data.size, data.total);
    const go = (page) => fetchTransfers(isConfirmed, page, data.size);
    return (
      <div className="card-footer d-flex flex-wrap justify-content-between align-items-center">
        <div className="d-flex align-items-center mb-2 mb-md-0">
          <small className="text-muted mr-3">
            {from}-{to} sur {data.total}
          </small>
          <select
            className="form-control form-control-sm"
            style={{ width: 80 }}
            value={data.size}
            disabled={loading}
            onChange={(e) =>
              fetchTransfers(isConfirmed, 0, parseInt(e.target.value, 10))
            }
          >
            {PAGE_SIZES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${data.page === 0 || loading ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => go(data.page - 1)}
              disabled={data.page === 0 || loading}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
          </li>
          {pageNumbers(data.page, data.totalPages).map((p) =>
            typeof p === "string" ? (
              <li className="page-item disabled" key={p}>
                <span className="page-link">…</span>
              </li>
            ) : (
              <li
                className={`page-item ${p === data.page ? "active" : ""}`}
                key={p}
              >
                <button
                  className="page-link"
                  style={
                    p === data.page
                      ? { backgroundColor: "#343a40", borderColor: "#343a40" }
                      : { color: "#343a40" }
                  }
                  onClick={() => go(p)}
                  disabled={loading}
                >
                  {p + 1}
                </button>
              </li>
            )
          )}
          <li
            className={`page-item ${
              data.page >= data.totalPages - 1 || loading ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => go(data.page + 1)}
              disabled={data.page >= data.totalPages - 1 || loading}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </li>
        </ul>
      </div>
    );
  };

  const renderTransfersCard = (title, icon, data, isConfirmed, loading) => {
    const transfers = data.items.filter(matchesStatus);
    const withConfirm = !isConfirmed;
    return (
      <div className="card card-outline card-dark mb-4" style={cardStyle}>
        <div className="card-header">
          <h3 className="card-title">
            <i className={`${icon} mr-2`}></i>
            {title}
            <span className="badge badge-dark ml-2">{data.total}</span>
          </h3>
          <div className="card-tools">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="collapse"
              title="Réduire"
            >
              <i className="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <div className="card-body p-0 table-responsive">
          <table className="table table-hover table-striped mb-0">
            <thead className="thead-light">
              <tr className="text-center">
                <th>Référence</th>
                <th>Source</th>
                <th>Destination</th>
                <th>Date de création</th>
                <th>Date limite</th>
                <th>Statut</th>
                {withConfirm && <th>Confirmer</th>}
                <th>Info</th>
              </tr>
            </thead>
            <tbody>
              {loading && transfers.length === 0 && (
                <tr>
                  <td
                    colSpan={withConfirm ? 8 : 7}
                    className="text-center text-muted py-4"
                  >
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Chargement...
                  </td>
                </tr>
              )}
              {!loading && transfers.length === 0 && (
                <tr>
                  <td
                    colSpan={withConfirm ? 8 : 7}
                    className="text-center text-muted py-4"
                  >
                    <i className="fas fa-exchange-alt fa-2x mb-2 d-block"></i>
                    Aucun transfert trouvé
                  </td>
                </tr>
              )}
              {transfers.map((element) => (
                <tr
                  key={element.id}
                  className="text-center"
                  style={loading ? { opacity: 0.5 } : undefined}
                >
                  <td>
                    <span className="badge badge-light border">
                      {element.reference}
                    </span>
                  </td>
                  <td>{element.warehouseSourceName}</td>
                  <td>{element.warehouseDestinationName}</td>
                  <td>{element.creation_date}</td>
                  <td>{element.deadline}</td>
                  <td>{stateBadge(element.state)}</td>
                  {withConfirm && (
                    <td>
                      <button
                        type="button"
                        title="Confirmer le transfert"
                        className="btn btn-sm btn-outline-success"
                        style={{ width: 36 }}
                        onClick={() => onConfirmHandler(element.id)}
                      >
                        <i className="fas fa-check"></i>
                      </button>
                    </td>
                  )}
                  <td>
                    <button
                      type="button"
                      title="Voir les produits du transfert"
                      className="btn btn-sm btn-outline-dark"
                      style={{ width: 36 }}
                      onClick={() => onViewProductsHandler(element.reference)}
                    >
                      <i className="fas fa-shopping-cart"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {renderPagination(data, isConfirmed, loading)}
      </div>
    );
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <h4 className="mb-1">
            <i className="fas fa-check-double mr-2"></i>Confirmation des
            transferts
          </h4>
          <small className="text-muted">
            Confirmez les demandes de transfert en attente et consultez celles
            déjà confirmées
          </small>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="card card-outline card-dark" style={cardStyle}>
            <div className="card-body py-3">
              <div className="row align-items-end">
                <div className="col-md-4">
                  <div className="form-group mb-0">
                    <label
                      htmlFor="statusFilter"
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.03em",
                        color: "#6c757d",
                      }}
                    >
                      <i className="fas fa-filter mr-1"></i>Statut
                    </label>
                    <select
                      id="statusFilter"
                      className="form-control"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                    >
                      {STATUS_OPTIONS.map((o) => (
                        <option key={o.value} value={o.value}>
                          {o.label}
                        </option>
                      ))}
                    </select>
                    {statusFilter !== "all" && (
                      <small className="text-muted">
                        Le filtre s'applique à la page affichée.
                      </small>
                    )}
                  </div>
                </div>
                {statusFilter !== "all" && (
                  <div className="col-md-3 mt-2 mt-md-0">
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => setStatusFilter("all")}
                    >
                      <i className="fas fa-undo mr-1"></i>
                      Réinitialiser
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {renderTransfersCard(
            "Les demandes de transfert non confirmées",
            "fas fa-hourglass-half",
            unconfirmed,
            0,
            loadingUnconfirmed
          )}
          {renderTransfersCard(
            "Les demandes de transfert confirmées",
            "fas fa-check-circle",
            confirmed,
            1,
            loadingConfirmed
          )}
        </div>
      </section>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ConfirmTransfert);
